// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__b8l2w","img":"style_img__n37KM"};